function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "expand_less_FILL0_wght400_GRAD0_opsz48 2"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M5.89583 12.8118L5 11.916L10 6.91602L15 11.8952L14.1042 12.791L10 8.68685L5.89583 12.8118Z",
  fill: "#707070"
}));
function SvgFigmaArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigmaArrow);
export default __webpack_public_path__ + "static/media/figmaArrow.284a43803b4482db1c252bd127d5b65f.svg";
export { ForwardRef as ReactComponent };